<template>
  <!-- click.stop: the viewer sits inside the bump item, whose click toggles the bump -->
  <dialog
    ref="dialog"
    class="bump-photo-viewer"
    :class="{ 'bump-photo-viewer--fullscreen': isFullscreen }"
    @click.stop="onClickDialog"
    @close="onClose"
  >
    <template v-if="src">
      <div class="bump-photo-viewer__header">
        <p class="bump-photo-viewer__title">Foto Bump Produk</p>
        <button type="button" class="bump-photo-viewer__close" aria-label="Tutup" @click="close">
          <img v-if="isFullscreen" src="@/assets/icons/bump-zoom/close-blue.svg" alt="" width="28" height="28" />
          <img v-else src="@/assets/icons/bump-zoom/close-grey.svg" alt="" width="20" height="20" />
        </button>
      </div>
      <div class="bump-photo-viewer__body">
        <v-zoomer
          v-if="isFullscreen"
          class="bump-photo-viewer__zoomer"
          :style="{ width: '100%', height: '100%', touchAction: zoomed ? 'none' : 'auto' }"
          :zoomed.sync="zoomed"
        >
          <img :src="src" alt="Foto Bump Produk" class="bump-photo-viewer__image" />
        </v-zoomer>
        <img
          v-else
          :src="src"
          alt="Foto Bump Produk"
          class="bump-photo-viewer__image bump-photo-viewer__image--hover-zoom"
          @mousemove="zoom"
          @mouseleave="zoomReset"
        />
      </div>
    </template>
  </dialog>
</template>

<script>
export default {
  data() {
    return {
      src: null,
      isFullscreen: false,
      zoomed: false,
    };
  },
  methods: {
    open(src) {
      // full-screen viewer with pinch zoom on phones, modal with hover zoom elsewhere
      this.isFullscreen = window.matchMedia("(max-width: 767px)").matches;
      this.src = src;
      this.$refs.dialog.showModal();
      document.body.style.overflowY = "hidden";
    },
    close() {
      this.$refs.dialog.close();
      // the native close event is not always delivered on the first close, so reset here too
      this.onClose();
    },
    onClose() {
      document.body.style.removeProperty("overflow-y");
      this.src = null;
      this.zoomed = false;
    },
    onClickDialog(e) {
      if (e.target === this.$refs.dialog) {
        this.close();
      }
    },
    zoom(e) {
      const zoomImage = e.currentTarget;
      const { offsetX, offsetY } = e;
      zoomImage.style.transformOrigin = `${offsetX}px ${offsetY}px`;
      zoomImage.style.transform = "scale(2)";
    },
    zoomReset(e) {
      e.currentTarget.style.transform = "scale(1)";
    },
  },
};
</script>

<style scoped>
.bump-photo-viewer {
  width: 100%;
  max-width: 640px;
  padding: 0;
  border: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  outline: none;
}
.bump-photo-viewer::backdrop {
  background: rgba(0, 0, 0, 0.2);
}
.bump-photo-viewer__header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid #e0e9f4;
}
.bump-photo-viewer__title {
  flex: 1;
  margin: 0;
  padding-right: 20px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  color: #203551;
}
.bump-photo-viewer__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: #f6f8fc;
  cursor: pointer;
}
.bump-photo-viewer__body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* header (~61px) + dialog margins must still fit on short screens */
  max-height: calc(100vh - 110px);
  overflow: hidden;
}
.bump-photo-viewer__image {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  user-select: none;
}
.bump-photo-viewer__image--hover-zoom {
  cursor: zoom-in;
}

.bump-photo-viewer--fullscreen {
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: none;
  height: 100dvh;
  max-height: none;
  margin: 0;
  border-radius: 0;
  background: #0a0a0a;
}
.bump-photo-viewer--fullscreen:not([open]) {
  display: none;
}
.bump-photo-viewer--fullscreen .bump-photo-viewer__header {
  align-items: center;
  height: 56px;
  padding: 16px 20px;
  border-bottom: 0;
}
.bump-photo-viewer--fullscreen .bump-photo-viewer__title {
  padding-right: 0;
  font-weight: 700;
  color: #fff;
}
.bump-photo-viewer--fullscreen .bump-photo-viewer__close {
  width: 40px;
  height: 40px;
  border: 1.5px solid #e0e9f4;
}
.bump-photo-viewer--fullscreen .bump-photo-viewer__body {
  flex: 1;
  aspect-ratio: auto;
  max-height: none;
}
/* center the photo inside vue-zoomer's wrappers, like the classic theme does */
.bump-photo-viewer__zoomer,
.bump-photo-viewer__zoomer >>> div {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
